<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content myInfo">
                        <div>
                            <el-tabs stretch v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="学员信息" name="studentInfo">
                                    <student-info-com></student-info-com>
                                </el-tab-pane>
                                <el-tab-pane label="修改密码" name="changePass">
                                    <change-password></change-password>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../../common/commonHeader.vue"; //头部组件
import leftMenu from "../../common/leftMenu.vue"; //头部组件
import exit from "../../common/exit.vue"; //头部组件
import studentInfoCom from "./studentInfo.vue"; //头部组件
import changePassword from "./changePassword.vue"; //头部组件
export default {
    name: 'index',
    components: {
        commonheader,
        leftMenu,
        exit,
        studentInfoCom,
        changePassword
    },
    data () {
        return {
            activeName: 'studentInfo',
            dengmiQueryForm: {}
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
    },
    methods: {
        handleClick (tab, event) {
            console.log(tab, event);
        }
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding-top 47px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    padding-bottom 50px
</style>
<style>
.myInfo .el-tabs__header {
    margin-bottom: 50px;
}
.myInfo .el-tabs__nav-wrap.is-top {
    width: 200px;
    margin: auto;
}
.myInfo .el-tabs__nav-wrap::after {
    background: transparent;
}
.myInfo .el-tabs__active-bar {
    height: 4px;
    background: transparent url("../../../assets/images/tabAfterBorder.png");
    background-size: 100% 100%;
}

.myInfo div[role="tab"] {
    font-size: 16px;
    color: #333;
}
.myInfo .el-tabs__item.is-active {
    color: $textColorBlue;
}
</style>


// WEBPACK FOOTER //
// src/components/my/myInfo/index.vue